import HeroSection from "@/components/HeroSection";
import EntryBlocks from "@/components/EntryBlocks";
import CoreGateways from "@/components/CoreGateways";
import CarbonMarketExplainer from "@/components/CarbonMarketExplainer";
import GlobalMarketData from "@/components/GlobalMarketData";
import GlobalPolicySection from "@/components/GlobalPolicySection";
import IndiaCommitmentSection from "@/components/IndiaCommitmentSection";
import TalkToExpert from "@/components/TalkToExpert";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      {/* 1. Hero Section */}
      <HeroSection />

      {/* 2. Entry Blocks - Clear paths for users */}
      <EntryBlocks />
      
      {/* 3. Core Gateways */}
      <CoreGateways />
      
      {/* 4. Carbon Market Explainer */}
      <CarbonMarketExplainer />
      
      {/* 5. Global Carbon Market Data */}
      <GlobalMarketData />
      
      {/* 6. Global Policy Section */}
      <GlobalPolicySection />
      
      {/* 7. India Commitment */}
      <IndiaCommitmentSection />

      {/* 8. Talk to an Expert CTA */}
      <TalkToExpert />
    </div>
  );
}
